import React from 'react';
import { Logo } from "./index";

function LazyLoader() {
  return (
    <div className='initial-app-loader d-flex justify-content-center align-items-center'>
      <div className='d-flex flex-column align-items-center'>
        <Logo width="100" />
        <h5>Please Wait....</h5>
      </div>
    </div>
  );
}
export default LazyLoader;